import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControlsDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGamepadControlsDown"><Path d="M8 2H16V7.16421L12 11.1642L8 7.16421V2Z" fill="currentColor"/><Path d="M16.8358 8H22V16H16.8358L12.8358 12L16.8358 8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8 16.8358V22.25H16V16.8358L12 12.8358L8 16.8358ZM14 17.6642V20.25H10V17.6642L12 15.6642L14 17.6642Z" fill="currentColor"/><Path d="M2 8V16H7.16421L11.1642 12L7.16421 8H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepadControlsDown;
